import { getAuthUser } from '../utils/authUser.js'
import { fetchGetJson } from "../utils/fetch-json.js"
import { el, mount } from "redom"
import { RecordItemWithImage } from "../records/components/record-item.js"
import RecordTable from "../records/components/record-table.js"
import { buildTopLinks, buildBottomSoundcorset, buildBottomLinks } from "../utils/layout.js"
import type { RecordsWithUser } from '#/types'

export async function welcomePageInit() {
    buildWelcomePage()

    const maybeMe = await getAuthUser()
    if (maybeMe.isDefined) return window.location.href = "/records";
    (document.querySelectorAll('a[href*="#"]:not([href="#"])') as NodeListOf<HTMLAnchorElement>).forEach((anchor: HTMLAnchorElement) => {
        anchor.addEventListener("click", function (e) {
            const currentPath = window.location.pathname.replace(/^\//, "");
            const anchorPath = this.pathname.replace(/^\//, "");
            const samePage = currentPath === anchorPath || window.location.hostname === this.hostname;
            if (samePage) {
                const hash = this.hash;
                let target: HTMLElement | null = document.querySelector(hash)
                if (!target) {
                    const name = hash.slice(1);
                    target = document.querySelector(`[name="${name}"]`);
                }
                if (target) {
                    e.preventDefault();
                    window.scrollTo({
                        top: target.offsetTop,
                        behavior: "smooth"
                    });
                }
            }
        });
    });
    

    fetchGetJson<RecordsWithUser[]>("/v1/playlist/featured").then(
        records => {
            const featured = new RecordTable(RecordItemWithImage)
            records && records.length ? featured.init(records.slice(0,10), { hardRefresh: true }) : mount(featured, el("center", el("h4.noMargin", {innerText: "No files to show", style:"padding:70px 0"})))
            const button = el("button.showMore btn btn-light", { type: 'button', innerText: "SHOW MORE" })
            button.onclick = () => { window.location.href = "records" }
            const featuredEL = document.getElementById("featuredRecords")
            if(featuredEL) mount(featuredEL, featured)
            mount(featured, button)
        }
    )
}

const buildWelcomePage = () => {
    const welcomeDiv = document.getElementById("welcome")
    const topLink = document.getElementById("top-link")
    if(!welcomeDiv || !topLink) return
    mount(welcomeDiv, buildTopLinks(), topLink,  true)
    mount(welcomeDiv, buildBottomSoundcorset())
    mount(welcomeDiv, buildBottomLinks())

}
